const TurboFlakes = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156.84 156.84">
    <circle
      cx={78.42}
      cy={78.42}
      r={78.42}
      style={{
        fill: "#ed1c24",
      }}
    />
    <circle
      cx={53.96}
      cy={108.04}
      r={13.17}
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M98.23 78.64a13.17 13.17 0 0 1-13.17 13.17c-7.27 0-37.64-13.17-37.64-13.17s30.37-13.17 37.64-13.17a13.17 13.17 0 0 1 13.17 13.17ZM116.59 49a13.17 13.17 0 0 1-13.17 13.17C96.15 62.18 53.54 49 53.54 49s42.6-13.17 49.88-13.17A13.17 13.17 0 0 1 116.59 49Z"
      transform="translate(-.52 -.22)"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);

export default TurboFlakes;
